(() => {
    const artifactsUrl = '/service/memories/manager/artifacts/'
    const getTagsParam = 'includeTags=true'

    function getArtifact(id) {
        if (FS.showEx("tempStopHomeRefreshEx")) {
            FS.fetchDefaults.statusCallbacks[401] = ()=>{};
        }
        return FS.fetch(`${artifactsUrl}${id}?${getTagsParam}`)
    }

    window.Home = window.Home || {}
    Home.Artifacts = {
        getArtifact
    }
  })()

